<template>
  <v-select v-model="internalValue" :items="visibleIcons" item-title="title" item-value="icon"
    @update:modelValue="updateIcon" hide-details variant="solo" density="compact" menu-icon="fal fa-chevron-down"
    :menu-props="{ class: 'kyano-menu ui-menu' }">
    <template #selection="{ item, index }">
      <ui-icon :name="item.title" />
    </template>

    <template #item="{ props, item }">
      <ui-list-item v-bind="props" :icon="item.raw.icon" label=""> </ui-list-item>
    </template>
  </v-select>
</template>

<script>
import { lucideIcons } from "@/util/Icons";

export default {
  name: "UIIcon",
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    defaultIcon: {
      type: String,
      default: "comment",
    },
  },
  data() {
    return {
      filter_icons: "",
      icons_list: lucideIcons(),
      visibleCount: 40, // Hoeveel iconen we tonen per batch
    };
  },
  computed: {
    filteredIcons() {
      return this.icons_list.filter((item) =>
        item.title.toLowerCase().includes(this.filter_icons.toLowerCase())
      );
    },
    visibleIcons() {
      return this.filteredIcons.slice(0, this.visibleCount);
    },
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
  methods: {
    updateIcon(newIcon) {
      this.$emit("update:modelValue", newIcon); // modelValue bijwerken
      this.$emit("change", newIcon);

      const menu = this.$refs.menu;
      if (menu && menu.isActive !== undefined) {
        menu.isActive = false;
      }
    },
    handleScroll(event) {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      const bottomReached = scrollTop + clientHeight >= scrollHeight - 10;

      if (bottomReached && this.visibleCount < this.filteredIcons.length) {
        this.visibleCount += 40; // Laad volgende batch
      }
    },
  },
  // De 'updated' lifecycle hook wordt hier toegevoegd
  updated() {
    this.$nextTick(() => {
      // Forceer opnieuw genereren van iconen met lucide.createIcons()
      lucide.createIcons();
    });
  },
};
</script>
